import React from 'react'
import { Header2 } from '../../styles/Components'
import MarketsList from '../MarketsList'
import { MarketsMapWrapper } from './styles'

const MarketsMap = () => (
  <MarketsMapWrapper aria-label="Markets we serve">
    <Header2 align="center" className="map-heading">Glam wherever you go</Header2>
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      src="/about-us/markets-map.svg"
      alt="Map of the United States highlighting the cities where Glamsquad offers on-demand at-home beauty services"
      className="map-image"
      loading="lazy"
      decoding="async"
      width="1264"
      height="792"
    />
    <MarketsList />
  </MarketsMapWrapper>
)

export default MarketsMap
